module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade bs-example-modal-lg sync-in-progress",
    attrs: {
      "id": "sync-in-progress-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body  modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-align-center form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/verify-email--red.png",
      "width": "150",
      "alt": "mail"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-red"
  }, [_c('strong', [_vm._v("\n                      " + _vm._s(_vm.$t('home.verify_modal_text_1')) + "\n                    ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('home.sync_data_of_platform')))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-50"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#sync-in-progress-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.ok")))])])]), _vm._v(" "), _c('br'), _c('br')])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-068f5703"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/sync-in-progress-modal/modal.vue
// module id = 1315
// module chunks = 0